<template>
  <div class="changeStatus">
    <section>
      <el-form
        :model="form"
        :rules="rules"
        ref="ruleForm"
        label-suffix=":"
        style="padding-bottom: 50px;"
        class="demo-ruleForm"
      >
        <li class="redText">
          注意：※为必填项
        </li>
        <li class="flex_input">
          <div class="lable_left">
            <span class="redText">※</span> 房主姓名：
          </div>
          <el-form-item class="input_right" prop="name">
            <el-input placeholder="请输入房主姓名" v-model="form.name" type="text"/>
          </el-form-item>
        </li>
        <li class="flex_input">
          <div class="lable_left">
            <span class="redText">※</span> 房屋地址：
          </div>
          <el-form-item class="input_right" prop="address">
            <el-input placeholder="请输入房屋地址" readonly v-model="form.address" type="text"/>
          </el-form-item>
        </li>
        <li class="li_flex">
          <div class="lable_left">
            <span class="redText">※</span> 证件类型：
          </div>
          <div class="input_right">
            身份证
          </div>
        </li>

        <li class="flex_input">
          <div class="lable_left">
            <span class="redText">※</span> 证件号码：
          </div>
          <el-form-item class="input_right" prop="idNumber">
            <el-input placeholder="请输入证件号码" v-model="form.idNumber" type="text"/>
          </el-form-item>
        </li>
        <li class="flex_input">
          <div class="lable_left">
            <span class="redText">※</span> 手机号：
          </div>
          <el-form-item class="input_right" prop="mobNo">
            <el-input placeholder="请输入联系电话" v-model="form.mobNo" type="text"/>
          </el-form-item>
        </li>
        <li class="flex_input" v-if="captchaValidate">
          <div class="lable_left">
            <span class="redText">※</span> 验证码：
          </div>
          <el-form-item class="input_right" prop="captcha">
            <el-input placeholder="验证码" style="width: 60%;" v-model="form.captcha" type="text"/>
            <button :disabled="disabled" type='button' @click.stop="getYzm" class="yzmBtn" style="width: 38%;">{{msg}}</button>
          </el-form-item>
        </li>
        <li>
          <span class="greyText">面积信息 </span>
        </li>
        <div v-for="(v, index) in options" :key="index" class="item">
          <mt-checklist
            v-model="value"
            :options="[
            { label: `收费面积:${ v.sfmj }m²,建筑面积:${ v.zdmj }m²` , value: v.id },
          ]"
            @change="checkon($event)"
          ></mt-checklist>
        </div>

        <li>
          <span class="redText" style="margin-right: 5px;">※ </span> 身份证上传：<span class="buleText" @click="sfzFlag=!sfzFlag">查看样例</span>
        </li>
        <div class="file" v-if="imageId">
          <input
            type="file"
            accept="image/*"
            name="uploader-input"
            class="uploader-file"
            @change="getId"
          />身份证正面
        </div>
        <div class="file" v-if="imageIdBack">
          <input
            type="file"
            accept="image/*"
            name="uploader-input"
            class="uploader-file"
            @change="getIdBack"
          />身份证背面
        </div>
        <div v-for="(item,ind) in imgIdList" :key="ind" class="imgDiv">
          <b @click="deleteImgId(ind)" class="el-icon-error error_icon"></b>
          <img class="imgItemRead avatar" :src="item" alt="">
        </div>
        <div v-for="(item,ind) in imgIdBackList" :key="ind" class="imgDiv">
          <b @click="deleteImgIdBack(ind)" class="el-icon-error error_icon"></b>
          <img class="imgItemRead avatar" :src="item" alt="">
        </div>
        <li>
          房产证或购房合同上传：
        </li>
        <li>
          <span class="redText" style="font-size: 10px">注意：仅需上传户主信息、房屋信息及签章页</span>
        </li>
        <div class="file">
          <input
            multiple="multiple"
            type="file"
            accept="image/*"
            name="uploader-input"
            class="uploader-file"
            @change="getIdHt"
          />房产证或购房合同
        </div>
        <div v-for="(item,ind) in imgHtList" :key="ind" class="imgDiv">
          <b @click="deleteHtId(ind)" class="el-icon-error error_icon"></b>
          <img class="imgItemRead avatar" :src="item" alt="">
        </div>
      </el-form>
    </section>
<!--    <el-checkbox-group style="margin-bottom: 5px;" v-model="checkedCities">-->
<!--      <el-checkbox label="1" ><span class="buleText" @click="getXy">我已确认信息，对协议无异议。</span></el-checkbox>-->
<!--    </el-checkbox-group>-->
    <button v-if="options.length" class="btn_bx" type='button' @click.stop="changeStatus">
      申 请 复 供
    </button>
    <mt-popup
    v-model="sfzFlag"
    class="xy"
    @click="sfzFlag=!sfzFlag"
    popup-transition="popup-fade"
    >
      <img class="sfzsl" src="../../../../static/image/sfzsl.jpg" alt="">
    </mt-popup>
  </div>
</template>

<script>
  import {findArea, getCaptcha, getUser, saveMjfg, saveMjtg} from "@/api";
  import { Popup } from 'mint-ui';
  import {isCnNewID, validatePhone} from "@/utils";
  export default {
    data() {
      return {
        value: [],
        questionName: "多选标题1",
        options: [],
        form: {},
        rules: {
          mobNo: [
            {
              required: true, message: '必填'
            },
            { validator: validatePhone, trigger: 'blur' }
          ],
          idNumber: [
            {
              required: true, message: '必填'
            },
            {validator: isCnNewID,trigger: "blur"}
          ],
          tgyy: [
            {
              required: true, message: '必填'
            }
          ],
          name: [{
            required: true, message: '必填'
          }],
          address: [
            {
              required: true, message: '必填'
            }
          ],
          lnbt: [
            {
              required: true, message: '必填'
            }
          ],
          captcha: [
            {
              required: true, message: '必填'
            }
          ],
        },
        fileList: [],
        imgList: [],
        imgIdList: [],
        imgIdBackList: [],
        imageIdHt: true,
        imgHtList: [],
        imageId: true,
        imageIdBack: true,
        imagefcz: true,
        sfzFlag: false,
        imgHref: '',
        maxtime: 60, // 一个小时，按秒计算，自己调整!
        timer: null,
        msg: '获取验证码',
        disabled: false,
        checkedCities: [],
        xyFlag: false,
        xczpFlag: true,
        imgXcList: [],
        captchaValidate: true
      };
    },
    mounted() {
      this.getAreaList();
      this.getUser()
      this.captchaValidate = JSON.parse(sessionStorage.getItem('roles'))&&JSON.parse(sessionStorage.getItem('roles')).captchaValidate

    },
    methods: {
      getUser() {
        getUser({
          code: this.$route.query.code,
        }).then((res) => {
          this.$set(this.form,'address',res.data.address)
        });
      },
      getAreaList() {
        findArea({
          customerId: this.$route.query.userId,
        }).then((res) => {
          this.options = res.data;
        });
      },
      checkon(e) {
        console.log(e);
      },
      getId(e) {
        let file = e.target.files[0]
        this.fileList.push(file);
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {    //成功读取文件
          this.imgIdList.push(e.target.result)
        };
        this.imageId = false
      },
      getIdBack(e) {
        let file = e.target.files[0]
        this.fileList.push(file);
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {    //成功读取文件
          this.imgIdBackList.push(e.target.result)
        };
        this.imageIdBack = false
      },
      getIdHt(e) {
        let fileList = e.target.files
        for(var i=0;i<fileList.length;i++){
          let file=fileList[i];                 /* 获取单个File对象 */
          this.fileList.push(file);
          var reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = (e) => {    //成功读取文件
            this.imgHtList.push(e.target.result)
          };
        }
        this.imageIdHt = false
      },
      getXc(e) {
        let file = e.target.files[0]
        this.fileList.push(file);
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {    //成功读取文件
          this.imgXcList.push(e.target.result)
        };
        this.xczpFlag = false
      },
      deleteXc(ind) {
        this.imgXcList.splice(ind, 1);
        this.fileList.splice(ind, 1)
        this.xczpFlag = true
      },
      deleteHtId(ind) {
        this.imgHtList.splice(ind, 1);
        this.fileList.splice(ind, 1)
        this.imageIdHt = true
      },
      deleteImgId(ind) {
        this.imgIdList.splice(ind, 1);
        this.fileList.splice(ind, 1)
        this.imageId = true
      },
      deleteImgIdBack(ind) {
        this.imgIdBackList.splice(ind, 1);
        this.fileList.splice(ind, 1)
        this.imageIdBack = true
      },
      getYzm() {
        var reg_tel = /^(1)\d{10}$/;
        if(!reg_tel.test(this.form.mobNo)) {
          this.$toast('请输入正确的手机号码')
          return
        }
        let params = {
          sysType: 0,
          phone: this.form.mobNo,
        }
        getCaptcha(params).then(res=>{
          if(res.code=='0000') {
            this.maxtime = 60
            this.disabled = true
            this.timer = setInterval(() => {
              this.CountDown()
            }, 1000)
          }
        })
      },
      CountDown() {
        if (this.maxtime > 0) {
          let seconds = this.maxtime;
          this.msg = +seconds + "s" + '后获取';
          --this.maxtime;
        } else {
          clearInterval(this.timer);
          this.msg = '获取验证码'
          this.disabled = false
        }
      },
      changeStatus() {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            if (!this.value.length) {
              this.$toast("请选择要停供的面积");
              return false;
            }
            if (this.imageId) {
              this.$toast("请上传身份证正面照片");
              return false;
            }
            if (this.imageIdBack) {
              this.$toast("请上传身份证背面照片");
              return false;
            }
            var formdata = new FormData();
            this.form.customerId = this.$route.query.userId
            for (let k in this.form) {
              formdata.append(k, this.form[k]);
            }
            this.fileList.map(file => {
              formdata.append("files", file);
            })
            formdata.append("areaList", this.value.join());
            saveMjfg(formdata).then(res => {
              if (res.code == '0000') {
                this.$toast("操作成功");
                this.$router.go(-1)
              }
            })
          }

        })

      },
      getXy() {
        this.xyFlag = true
      }
    }
    ,
  }
  ;
</script>

<style>
  .changeStatus {
    padding: 3%;
    min-height: 90%;
    background: #fff;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    height: 90%;
  }
  .yzmBtn{
    border: 1px solid #C2E7B0;
    border-radius: 3px;
    line-height: 26px;
    background: #F0F9EB;
    color: #67C23A;
    font-size: 12px;
    /*background: #000;*/
  }
  .xy{
    background: #fff;
    height: 80vh;
    width: 90%;
    border-radius: 5px;
    overflow-y: auto;
    /*margin-left: 5%;*/
    padding: 5px;
  }
  .changeStatus .mint-cell-wrapper {
    font-size: 14px !important;
  }

  .changeStatus .buleText {
    color: #1E88C7;
    font-size: 12px;
  }

  .changeStatus v.mask {
    position: fixed;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, .4);
  }

  .changeStatus .btn_bx {
    width: 100%;
    /*margin-top: 3rem;*/
    font-size: 1rem;
    height: 2.5rem;
    background: #47c34d;
    border-radius: 3px;
  }

  header, footer {
    height: 60px;
    line-height: 60px;

    /*text-align:center;*/
  }

  header {
    margin-bottom: 5px;
    background-color: #fff;

  }

  section {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    width: 100%;
    overflow: auto; /* winphone8和android4+ */
    -webkit-overflow-scrolling: touch; /* ios5+ */
  }

  .sfzsl {
    width: 90%;
    height: 80vh;
    left: 5%;
    border-radius: 10px;
    position: absolute;
  }

  .redText {
    color: red;
  }

  .lable_left {
    width: 100px;
    color: black;
  }

  .flex_input {
    display: flex;
    line-height: 40px;
  }

  .changeStatus li {
    line-height: 40px;
    display: flex;
    border-bottom: 1px solid #F7F6F7;
  }

  .li_flex {
    justify-content: space-between;
  }

  .lable_right {
    color: #949393;
  }

  .greyText {
    color: #8c939d;
    margin-right: 10px;
  }

  .input_right {
    flex: 1;
    color: black;
  }

  .changeStatus .el-input__inner {
    padding: 0 !important;
  }

  .changeStatus .input_right input, .input_right textarea {
    border: none;
    outline: none;
    float: 1;
    margin-top: 5px;
  }

  .changeStatus .el-form-item {
    margin-bottom: 0 !important;
  }

  .itemList {
    /* border-bottom: 1px solid #fcfcfc; */
    color: #646262;
    /* padding-left: 8%; */
  }

  /*.mint-cell-wrapper {*/
  /*  padding: 0 !important;*/
  /*}*/
  .item {
    /* border-bottom: 1px solid #f1f1f1;
    padding-bottom: 20px; */
  }

  .uploader-file {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .uploader-file:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 100%;
    height: 178px;
    display: block;
    margin-top: 25px;
  }

  .file {
    width: 90%;
    height: 30px;
    position: relative;
    display: inline-block;
    background: #FBFDFF;
    border: 1px #C0CCDA dashed;
    border-radius: 4px;
    padding: 4px 12px;
    overflow: hidden;
    color: #1E88C7;
    text-decoration: none;
    text-indent: 0;
    text-align: center;
    line-height: 30px;
  }

  .file input {
    position: absolute;
    font-size: 100px;
    right: 0;
    top: 0;
    opacity: 0;
  }

  .file:hover {
    background: #FBFDFF;
    border-color: #AADFFD;
    color: #004974;
    text-decoration: none;
  }

  .imgDiv {
    position: relative;
  }

  .error_icon {
    position: absolute;
    font-size: 25px;
    right: 0px;
    top: 0px;
    z-index: 999999;
    color: #f00;
  }

</style>



// WEBPACK FOOTER //
// src/view/ywbl/fg/changeStatus.vue